export default __webpack_public_path__ + "static/media/logo.9ccd3a61.svg";